import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="testimonials-title" data-id="element-228" data-mp="1n0aifuwodh2y">
      <div className="mx-auto max-w-6xl px-5" data-id="element-229" data-mp="1r1m5pts2tq7z">
        <div className="flex flex-col items-center gap-3 text-center" data-id="element-230" data-mp="1r0b3hyea4qiz">
          <HeartIcon className="h-6 w-6 fill-rose-500 text-rose-500" aria-hidden="true" data-id="element-231" data-mp="1d1l8cob0t0x9" />
          <h2 id="testimonials-title" className="font-display text-3xl uppercase text-cream sm:text-4xl" data-id="element-232" data-mp="1i1h09p6g11wg">
            Más mujeres que ya lo tienen
          </h2>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-233" data-mp="181zxpgmhn44p">
          {testimonials.map((t, i) => <motion.li key={t.name} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: Math.min(i * 0.06, 0.3),
          ease: 'easeOut'
        }} data-id="element-234" data-mp="2yg8rvzvrm54p" data-mpi={i}>
              <figure className="flex h-full flex-col gap-4 rounded-2xl border border-cream/10 bg-ink-800 p-6" data-id="element-235" data-mp="2q1yeyfvg4vnh">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-236" data-mp="34qm526miwd61">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-237" data-mp="2c2girfftmg43" data-mpi={s} />)}
                </div>
                <blockquote className="text-sm leading-relaxed text-cream/80" data-id="element-238" data-mp="2m1nwi3qgwcrq">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 border-t border-cream/10 pt-4" data-id="element-239" data-mp="2h45w51qin5vc">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-rose-600/25 text-xs font-bold text-rose-300" data-id="element-240" data-mp="3sgyn4abhfqac">
                    {t.initials}
                  </span>
                  <span className="text-xs text-cream/55" data-id="element-241" data-mp="3h50q92xd7ze">
                    <span className="block text-sm font-semibold text-cream/90" data-id="element-242" data-mp="8cahyuldtyh5">{t.name}</span>
                    {t.city}
                  </span>
                </figcaption>
              </figure>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}